import {
    COUNTRY_SEARCH_REQUEST,
    COUNTRY_SEARCH_SUCCESS,
    COUNTRY_SEARCH_FAILURE,
    COUNTRY_KEYWORD_SEARCH_REQUEST,
    COUNTRY_KEYWORD_SEARCH_SUCCESS,
    COUNTRY_KEYWORD_SEARCH_FAILURE,
    // COUNTRY_SEARCH_PAGE_RESET_STATE,
    COUNTRY_TOGGLE_CHECKBOX,
    COUNTRY_TOGGLE_CHECKBOX_ALL,
    COUNTRY_CHANGE_INPUT_KEYWORD_VALUE,
} from '../../../actions/constants/actionTypesCountries';

// defaults
var defaultState = {
    selectedItems: {},
    selectedAll: false,
    countries: [],
    tablePages: -1,
    loading: false,
    errorMessage: null,
    modalOpen: false,
    modalAction: null,
    modalMessage: null,
    modalHeader: null,
    selectedCount: 0,
    inputKeywordValue: '',
};

export function countryReducer(state = defaultState, action) {
    let newState = Object.assign({}, state);
    let newSelectedItems = {};
    let stateResult;
    switch (action.type) {
        case COUNTRY_SEARCH_REQUEST:
            newState.loading = true;
            newState.errorMessage = null;
            return newState;
        case COUNTRY_SEARCH_SUCCESS:
            newState.loading = false;
            newState.countries = action.response.data || action.response;
            newState.countries.forEach(each => {
                newSelectedItems[each.id] = false;
            });
            newState.tablePages = action.response.totalNoOfPages;
            newState.selectedItems = newSelectedItems;
            newState.selectedAll = false;
            return newState;
        case COUNTRY_SEARCH_FAILURE:
            newState.loading = false;
            newState.errorMessage = action.error.message;
            newState.countries = [];
            return newState;
        // case COUNTRY_SEARCH_PAGE_RESET_STATE:
        // casereturn defaultState;
        case COUNTRY_KEYWORD_SEARCH_REQUEST:
            newState.loading = true;
            newState.errorMessage = null;
            newState.inputKeywordValue = action.inputKeywordValue;
            return newState;
        case COUNTRY_KEYWORD_SEARCH_SUCCESS:
            newState.loading = false;
            newState.countries = action.response.data || action.response;
            newState.countries.forEach(each => {
                newSelectedItems[each.id] = false;
            });
            newState.selectedItems = newSelectedItems;
            newState.selectedAll = false;
            return newState;
        case COUNTRY_KEYWORD_SEARCH_FAILURE:
            newState.loading = false;
            newState.errorMessage = action.error.message;
            newState.countries = [];
            return newState;
        case COUNTRY_TOGGLE_CHECKBOX:
            newSelectedItems = Object.assign({}, state.selectedItems);
            if (newSelectedItems[action.id] === undefined) {
                newSelectedItems[action.id] = true;
                newState.selectedCount = newState.selectedCount + 1;
            } else {
                newSelectedItems[action.id] = !newSelectedItems[action.id];
                if (newSelectedItems[action.id] === true) {
                    newState.selectedCount = newState.selectedCount + 1;
                } else {
                    newState.selectedCount = newState.selectedCount - 1;
                }
            }
            newState.selectedItems = newSelectedItems;
            return newState;
        case COUNTRY_TOGGLE_CHECKBOX_ALL:
            stateResult = !newState.selectedAll;
            newState.selectedAll = stateResult;
            if (newState.selectedAll === true) {
                newState.selectedCount = Object.keys(newState.selectedItems).length;
            } else {
                newState.selectedCount = 0;
            }
            for (let key in newState.selectedItems) {
                newState.selectedItems[key] = stateResult;
            }
            return newState;
        case COUNTRY_CHANGE_INPUT_KEYWORD_VALUE:
            newState.inputKeywordValue = action.inputKeywordValue;
            return newState;
        default:
            return state;
    }
}
